export default "__VITE_ASSET__CDRnu4mI__"